import withProxy from "../helpers/proxy.js";
import apiData from "./apis.json";
import maintainerData from "./maintainers.json";

const apis = apiData.records.map(({ fields }) => ({
  description: fields.description,
  featured: fields.featured,
  internal: !fields.isPublic,
  loginRequired: fields.loginRequired,
  maintainers: maintainerData.records
    .filter(({ id }) => (fields.maintainers || []).includes(id))
    .map(maintainer => maintainer.fields)
    .sort((a, b) => a.name.localeCompare(b.name)),
  name: fields.name,
  scope: fields.scope,
  tags: fields.tags?.sort((a, b) => a.localeCompare(b)),
  url: withProxy(fields.docsUrl),
}));

export default apis;
